import app from '../app';

app.directive('cianAfClickOutside', [
  '$document',
  '$parse',
  ($document, $parse) => ({
    link($scope, el, attr) {
      const clickOutside = $parse(attr.cianAfClickOutside);

      const documentClick = event => {
        if (event.clickOutsideTarget === el) {
          return;
        }
        $scope.$apply(function () {
          clickOutside($scope);
        });
      };

      const elementClick = event => {
        event.clickOutsideTarget = el;
      };

      $document.bind('click', documentClick);

      angular.element(el).bind('click', elementClick);

      $scope.$on('$destroy', () => {
        $document.unbind('click', documentClick);
        angular.element(el).unbind('click', elementClick);
      });
    },
  }),
]);
